module.exports = {
  "id": "blank project",
  "title": "New Project",
  "project_file": "blank project.gbp",
  "thumbnail": "/provision/projects/blank project/blank project.png",
  "category": "sandbox",
  "toolbar":{
    "glitches":[],
    "parts":[]
  }
}
;